/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from "react";
import moment from "moment";
import AccountsIcon from "assets/credit-report/accounts.svg";
import { TrueLinkCreditReportType } from "types";
import { ArrayUtils } from "utils";
import { Accordion } from "./Accordion";
import { getAccountDetails } from "../helpers";

interface CreditReportAccountsProps {
  accounts: TrueLinkCreditReportType["TradeLinePartition"];
  className?: string;
}

export const CreditReportAccounts = (props: CreditReportAccountsProps) => {
  const { accounts, className } = props;

  const groupedAccounts = ArrayUtils.groupItems(
    accounts,
    (account) => account.$.accountTypeSymbol,
  );

  return (
    <div className={className}>
      <div>
        <h2 className="text-2xl font-bold flex items-center">
          <img alt="" src={AccountsIcon} className="inline mr-2" />
          Accounts
        </h2>
        <div className="mt-4 space-y-6">
          {Object.entries(groupedAccounts).map(
            ([accountType, groupAccounts]) => (
              <div key={accountType}>
                <p className="font-bold">
                  {groupAccounts[0]?.$.accountTypeDescription}
                </p>
                <div className="mt-4 space-y-4">
                  {groupAccounts.map((account) => {
                    if (!account.Tradeline[0]) {
                      return null;
                    }
                    const actualAccount = account.Tradeline[0];

                    return (
                      <Accordion
                        key={account.Tradeline[0].$.accountNumber}
                        className="mt-4"
                        details={getAccountDetails(actualAccount)}
                        title="Account detail"
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex flex-col">
                            <p>{`${
                              actualAccount.$.creditorName
                            } (${actualAccount.$.accountNumber.slice(-4)})`}</p>
                            <p className="text-xs font-normal text-neutral-600">
                              Reported{" "}
                              {moment(actualAccount.$.dateReported).format(
                                "MM/DD/YYYY",
                              )}
                            </p>
                          </div>
                          <p className="font-normal">
                            ${actualAccount.$.currentBalance}
                          </p>
                        </div>
                      </Accordion>
                    );
                  })}
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};
